import { useEffect as d } from "react";

function c(e, n) {
  d(function () {
    var t = function t(o) {
      o.key === "Escape" && e && n();
    };

    return document.addEventListener("keydown", t), function () {
      document.removeEventListener("keydown", t);
    };
  }, [e, n]);
}

export { c as useEscKeyListener };